import { Component, OnInit, OnDestroy, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppState } from '../../../core/app-state';
import { FesBaseComponent } from '../../../shared/components/fes-base.component';
import { ScoutPoint, ScoutPath } from '../../../core/models';

@Component({
  selector: 'app-scout-point-paginator',
  templateUrl: './scout-point-paginator.component.html',
  styleUrls: ['./scout-point-paginator.component.scss']
})
export class ScoutPointPaginatorComponent extends FesBaseComponent implements OnInit, OnDestroy {

  // parent can set guard to conditionally prevent new selected task child (ex. editor has unsaved work)
  @Input() changeGuard : (current: ScoutPoint, acceptFn: ()=>void) => void = (c,a) => a()

  @Input() scoutPath : ScoutPath

  @Input() skipViaPoints : boolean = false

  @Output('pointSelected') selectedPointSubject = new BehaviorSubject<ScoutPoint>(null)

  bHasNext = false
  bHasPrevious = false

  constructor(appState : AppState, 
        private bsModalService: BsModalService ) {
    super(appState)
  }

  ngOnInit() {   
  }

  ngOnDestroy(): void {
    this.destroy()
  }

  getAvailablePoints() {
    return !this.skipViaPoints ? this.scoutPath.scoutPoints : this.scoutPath.scoutPoints.filter( pt => pt.type != 'VIA')
  }

  setSelected(scoutPoint:ScoutPoint) {
    console.log('setSelected('+ scoutPoint?.id + ')')
    const scoutPoints = this.getAvailablePoints()
    if ( !scoutPoint ) {
      this.moveToPrevious()
    } else {
      const ptIndex = scoutPoints.findIndex(pt=> pt.id == scoutPoint.id)
      this.bHasNext = ptIndex != -1 && ptIndex < scoutPoints.length -1
      this.bHasPrevious = ptIndex > 0
      this.selectedPointSubject.next(scoutPoint)
    }
  }
  

  //get scoutPoints() { return this.scoutPath?.scoutPoints }

  get selectedScoutPoint() { return this.selectedPointSubject.value }
  
  getPrevious() { 
    const scoutPoints = this.getAvailablePoints()
    const ptIndex = scoutPoints.findIndex(pt=> pt.id == this.selectedScoutPoint.id)
    return ptIndex > 0 ? scoutPoints[ptIndex-1] : null
  }
  
  getNext() { 
    const scoutPoints = this.getAvailablePoints()
    const ptIndex = scoutPoints.findIndex(pt=> pt.id == this.selectedScoutPoint.id)
    return ptIndex < scoutPoints.length -1 ? scoutPoints[ptIndex+1] : null
  }

  moveToPrevious = () => {
    const pt = this.getPrevious()
    if ( pt ) {
      this.setSelected(pt)
    }
  }

  moveToFirst = () => {
    const scoutPoints = this.getAvailablePoints()
    const ptIndex = scoutPoints.findIndex(pt=> pt.id == this.selectedScoutPoint.id)
    if ( scoutPoints?.length) {
      this.setSelected(scoutPoints[0])
    }
  }

  moveToNext = () => {
    const pt = this.getNext()
    if ( pt ) {
      this.setSelected(pt)
    }
  }

  moveToLast = () => {
    const scoutPoints = this.getAvailablePoints()
    const ptIndex = scoutPoints.findIndex(pt=> pt.id == this.selectedScoutPoint.id)
    if ( scoutPoints?.length) {
      this.setSelected(scoutPoints[scoutPoints.length-1])
    }
  }
  
  reset() {
    const scoutPoints = this.getAvailablePoints()
    this.setSelected( scoutPoints?.length ? scoutPoints[0] : null)
  }

}
